export default "<p>asignacion-manual works!</p>\r\n"